export default "__VITE_ASSET__DdemTpnV__"